import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.ChannelLabelSentiment extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'ChannelLabelSentiment-table-view'
  name: 'ChannelLabelSentiment-table-view'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  chartClass: 'ChannelLabelSentiment-table'

  initialize: (@options = {}) ->
    @colors = @options.colors

  render: ->
    @columns = ["Tematica", "Positivo", "Negativo", "Neutro", "Sin sentimiento"]
    @specific_settings ||= {}

    @specific_settings.benchmark = true
    @$el.html(@template(self: this))
    @bindChartsReady(1)
    @_getTable().addClass('processing')
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    page = @getTemplateOptions().page
    @setBenchmarkSettingsIfNecessary(query)
    $.post(@options.chartApi.label_sentiment + @getTemplateOptions().network, _.extend(query, {page: page}), (response) =>
      tableData = { columns: @columns, data: [], types: ['string', 'string', 'string', 'string', 'string'], options: { columns: { color: [{ name: 'Positivo', color: @colors['positive'] }, { name: 'Neutral', color: 'lightgrey' }, { name: 'Negativo', color: @colors['negative'] }] } } }
      for label in response
        tableData.data.push([label["name"], label["positive"], label["neutral"], label["negative"], label["unsentiment"]])
      @_getTable().html(new Monitoring.Reports.Executive.TableView(response: tableData).render().el)
    )
    return this

  _getTable: ->
    @$el.find(".#{@chartClass}")
